interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "GIP";
};

const GIP: Currency = Object.freeze({
  "displayName": "Gibraltar Pound",
  "numericCode": 292,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "GIP",
  "symbol": "£"
});

export { GIP };
